var exports = {
  "k": "MessageCharacterCounter.module__container___UnplOH",
};

module.exports = exports;
